import {
    GET_HOME,
    GET_HOME_SUCCESS,
    GET_HOME_FAILURE,
    UPDATE_HOME_STATUS,
    UPDATE_HOME_STATUS_SUCCESS,
    UPDATE_HOME_STATUS_FAILURE,
    UPDATE_HOME_ORDER_STATUS,
    UPDATE_HOME_ORDER_STATUS_SUCCESS,
    UPDATE_HOME_ORDER_STATUS_FAILURE,
    ADD_HOME,
    ADD_HOME_SUCCESS,
    ADD_HOME_FAILURE,
    EDIT_HOME,
    EDIT_HOME_SUCCESS,
    EDIT_HOME_FAILURE,
    DELETE_HOME,
    DELETE_HOME_SUCCESS,
    DELETE_HOME_FAILURE
} from "../Constants";

export const GetHome = () => ({
    type: GET_HOME
});

export const GetHomeSuccess = (payload) => ({
    type: GET_HOME_SUCCESS,
    payload
});

export const GetHomeFailure = (payload) => ({
    type: GET_HOME_FAILURE,
    payload
});

export const UpdateHomeStatus = (payload) => ({
    type: UPDATE_HOME_STATUS,
    payload
});

export const UpdateHomeStatusSuccess = (payload) => ({
    type: UPDATE_HOME_STATUS_SUCCESS,
    payload
});

export const UpdateHomeStatusFailure = (payload) => ({
    type: UPDATE_HOME_STATUS_FAILURE,
    payload
});

export const UpdateHomeOrderStatus = (payload) => ({
    type: UPDATE_HOME_ORDER_STATUS,
    payload
});

export const UpdateHomeOrderStatusSuccess = (payload) => ({
    type: UPDATE_HOME_ORDER_STATUS_SUCCESS,
    payload
});

export const UpdateHomeOrderStatusFailure = (payload) => ({
    type: UPDATE_HOME_ORDER_STATUS_FAILURE,
    payload
});

export const AddHome = (payload) => ({
    type: ADD_HOME,
    payload
});

export const AddHomeSuccess = (payload) => ({
    type: ADD_HOME_SUCCESS,
    payload
});

export const AddHomeFailure = (payload) => ({
    type: ADD_HOME_FAILURE,
    payload
});

export const EditHome = (payload) => ({
    type: EDIT_HOME,
    payload
});

export const EditHomeSuccess = (payload) => ({
    type: EDIT_HOME_SUCCESS,
    payload
});

export const EditHomeFailure = (payload) => ({
    type: EDIT_HOME_FAILURE,
    payload
});

export const DeleteHome = (payload) => ({
    type: DELETE_HOME,
    payload
});

export const DeleteHomeSuccess = (payload) => ({
    type: DELETE_HOME_SUCCESS,
    payload
});

export const DeleteHomeFailure = (payload) => ({
    type: DELETE_HOME_FAILURE,
    payload
});

